export default {
  apiEndpoint: 'https://mltmzibge1.execute-api.eu-west-1.amazonaws.com'
}

// TODO: Add the string '/prod' to the above url and remove it in the api calls
